import React from "react";
import "../../../../../css/games/funTargetTimer/title.css"
import funTargetTimer from "../../../../../../assets/titles/indie/targetTimer.svg";


export default function Title(props){
    return <div className="fd text_center">
    <img className='titleImg trgeImg' src={funTargetTimer} alt={funTargetTimer}></img>
</div>
}